import React, { useCallback } from 'react';
import clsx from 'clsx';
import { Checkbox } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useStyles } from './GroupRow.style';

export const GroupRow = ({
  displayName,
  groupMetaData,
  setOptionIsChosen,
  openCloseCb,
  isOpen,
  isClickable = true,
}) => {
  const classes = useStyles();

  const onClick = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <div
      className={clsx(classes.wrapperRegionRow, { [classes.wrapperRegion]: isClickable })}
      onClick={isClickable ? openCloseCb : undefined}
    >
      <div className={classes.checkAndName}>
        <Checkbox
          checked={groupMetaData?.allChosen}
          onChange={setOptionIsChosen}
          onClick={onClick}
        />
        <div className={classes.labelRegion}>{displayName}</div>
        {!!groupMetaData?.chosenCount && (
          <div className={classes.chosen}>{groupMetaData.chosenCount}</div>
        )}
      </div>
      {!!isClickable && (
        <KeyboardArrowUpIcon className={clsx({ [classes.subListOpened]: !isOpen })} />
      )}
    </div>
  );
};
